import {
    resolveApiBaseUrl,
    resolveSocketUrl,
    type RuntimeUrlEnvironment,
} from './runtimeUrlResolver';

const runtimeEnvironment = import.meta.env as unknown as RuntimeUrlEnvironment;
const currentOrigin = typeof window === 'undefined' ? undefined : window.location.origin;

export const API_BASE_URL = resolveApiBaseUrl(runtimeEnvironment);
export const SOCKET_URL = resolveSocketUrl(runtimeEnvironment, currentOrigin);
